import { ReactElement } from 'react';
import { HiddenPrice as HiddenPriceComponent } from '@client/common/components/HiddenPrice/HiddenPrice';
import classNames from 'classnames';
import { Price } from '../Price';
import { Props } from './';
import './HiddenPrice.scss';

export const HiddenPrice = ({ label, className }: Props): ReactElement => (
    <Price
      price={undefined}
      label={label}
      className={classNames(
        'CartProduct-HiddenPrice',
        className,
      )}
    >
      <HiddenPriceComponent isHiddenPriceAndNotCertified />
    </Price>
);
